import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Blogomat360 from './pages/Blogomat360';
import Chatbot360 from './pages/Chatbot360';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataDeletion from './pages/DataDeletion';
import FooterMain from './components/FooterMain';
import FooterBottomBar from './components/FooterBottomBar';
import CookieSettings from './components/CookieSettings';
import ContactFormTwo from './components/ContactFormTwo';
import '@n8n/chat/style.css';

import { createChat } from '@n8n/chat';

// Flag to prevent double sound in StrictMode
let badgeShown = false;

function App() {

  useEffect(() => {
    // Track user interaction
    let userInteracted = false;
    const markInteraction = () => { userInteracted = true; };

    document.addEventListener('click', markInteraction, { once: true });
    document.addEventListener('keydown', markInteraction, { once: true });
    document.addEventListener('touchstart', markInteraction, { once: true });

    // Show badge after 30s
    const badgeTimeout = setTimeout(() => {
      if (badgeShown) return;
      badgeShown = true;
      document.body.classList.add('show-chat-badge');
      if (userInteracted) {
        try {
          const audio = new Audio('/notification.mp3');
          audio.play().catch(() => {});
        } catch (e) {}
      }
    }, 30000);

    // Hide badge on toggle click
    const handleToggleClick = () => {
      document.body.classList.remove('show-chat-badge');
    };

    // Wait for chat to be mounted, then add listener
    const checkToggle = setInterval(() => {
      const toggle = document.querySelector('.chat-window-toggle');
      if (toggle) {
        toggle.addEventListener('click', handleToggleClick);
        clearInterval(checkToggle);
      }
    }, 100);

    return () => {
      clearTimeout(badgeTimeout);
      clearInterval(checkToggle);
      const toggle = document.querySelector('.chat-window-toggle');
      if (toggle) {
        toggle.removeEventListener('click', handleToggleClick);
      }
    };
  }, []);

  useEffect(() => {
    createChat({
      webhookUrl: 'https://n8n2.ai.scharmach.pl/webhook/c718e88b-a089-40ff-988f-b563222841c3/chat',
      webhookConfig: {
        method: 'POST',
        headers: {}
      },
      target: '#n8n-chat',
      mode: 'window',
      chatInputKey: 'chatInput',
      chatSessionKey: 'sessionId',
      loadPreviousSession: true,
      metadata: {},
      showWelcomeScreen: false,
      defaultLanguage: 'en',
      initialMessages: [
        "Hi there! 👋",
        "My name is Alex - I'm MarketingV8 virtual assistant. How can I assist you today?"
      ],
      i18n: {
        en: {
          title: 'V8 AI Assistant 🤖',
          subtitle: "Built with Chatbot 360 — ready to help you 24/7.",
          footer: '',
          getStarted: 'New Conversation',
          inputPlaceholder: 'Type your question..',
        },
      },
      enableStreaming: false,
    });
  }, []);

  const audio = new Audio('/notification.mp3');
  audio.play();

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <header className="App-header">
          <Header />
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogomat360" element={<Blogomat360 />} />
          <Route path="/chatbot360" element={<Chatbot360 />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
        </Routes>

        <div className='contact-popup'>
          <ContactFormTwo />
        </div>
        <footer className="App-footer">
          <FooterMain />
          <FooterBottomBar />
          <CookieSettings />

        </footer>
      </div>
    </Router>
  );
}

export default App;
